import Api from "../../../services/api";

export function loadGrid(params, cb) {
    return () => {
        Api.put('/w17f2181/Load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function getCboJobsType(cb) {
    return () => {
        Api.get('/w17f2180/Load-cbo-jobs-type')
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadStrCustomer(params, cb) {
    return () => {
        Api.put('/w17f2180/Load-cbo-customer', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function onDelete(params, cb) {
    return () => {
        Api.delete('/w17f2181/delete', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function onSave(params, cb) {
    return () => {
        Api.put('/w17f2181/save', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}
